import type {CSSProperties} from 'react'
import React from 'react'

function useEscapeSelectHidePopup() {
  const [isPressedEscape, setPressedEscape] = React.useState(false)
  const selectKeyDownHandler = (event: React.KeyboardEvent) => {
    const isPressEscapeKey = event.key === 'Escape'
    if (isPressEscapeKey && !isPressedEscape) {
      setPressedEscape(true)
      event.stopPropagation()
    } else if (isPressedEscape) {
      setPressedEscape(false)
    }
  }
  const pressedEscapePopupStyle: CSSProperties | undefined = isPressedEscape
    ? {visibility: 'hidden'}
    : undefined

  return {
    pressedEscapePopupStyle,
    selectKeyDownHandler,
  }
}

export default useEscapeSelectHidePopup
